/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wf_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter some text to see the most frequent words.`)
};

const es_wf_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa algo de texto para ver las palabras más frecuentes.`)
};

const de_wf_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie einen Text ein, um die häufigsten Wörter zu sehen.`)
};

const nl_wf_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer tekst in om de meest voorkomende woorden te zien.`)
};

const fr_wf_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez du texte pour voir les mots les plus fréquents.`)
};

const it_wf_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci del testo per vedere le parole più frequenti.`)
};

const pt_br2_wf_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite algum texto para ver as palavras mais frequentes.`)
};

const pt_wf_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza algum texto para ver as palavras mais frequentes.`)
};

const ja_wf_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストを入力して、最も頻繁に出現する単語を確認します。`)
};

const zh_wf_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入一些文本以查看最高频的单词。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wf_empty = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wf_empty(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wf_empty", locale)
	if (locale === "en") return en_wf_empty(inputs)
	if (locale === "es") return es_wf_empty(inputs)
	if (locale === "de") return de_wf_empty(inputs)
	if (locale === "nl") return nl_wf_empty(inputs)
	if (locale === "fr") return fr_wf_empty(inputs)
	if (locale === "it") return it_wf_empty(inputs)
	if (locale === "pt-BR") return pt_br2_wf_empty(inputs)
	if (locale === "pt") return pt_wf_empty(inputs)
	if (locale === "ja") return ja_wf_empty(inputs)
	return zh_wf_empty(inputs)
};